import { render, staticRenderFns } from "./RuleGenericDropdown.vue?vue&type=template&id=3c801106&scoped=true"
import script from "./RuleGenericDropdown.vue?vue&type=script&lang=ts"
export * from "./RuleGenericDropdown.vue?vue&type=script&lang=ts"
import style0 from "./RuleGenericDropdown.vue?vue&type=style&index=0&id=3c801106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c801106",
  null
  
)

export default component.exports